import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getLeagueSectionStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      backgroundColor: theme.background.card,
      borderRadius: 16,
      marginBottom: 14,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: theme.gray[200],
      ...(Platform.OS === 'web' && {
        boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
      }),
      shadowColor: theme.shadow ?? '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.12,
      shadowRadius: 8,
      elevation: 3,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 14,
      backgroundColor: theme.background.card,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
      gap: 10,
    },
    headerFlagWrap: {
      justifyContent: 'center',
    },
    headerText: {
      flex: 1,
      fontSize: 14,
      fontWeight: '800',
      color: theme.gray[800],
      textTransform: 'uppercase',
      letterSpacing: 0.8,
    },
    matchesList: {
      backgroundColor: theme.background.card,
    },
    headerPressed: {
      opacity: 0.8,
    },
    headerHover: {
      opacity: 0.95,
    },

    // ── Live count badge ──────────────────────────────────────────────────────
    liveCountBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      backgroundColor: theme.error + '1F',
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 9999,
    },
    liveCountDot: {
      width: 5,
      height: 5,
      borderRadius: 3,
      backgroundColor: theme.error,
    },
    liveCountText: {
      fontSize: 10,
      fontWeight: '800',
      color: theme.error,
      letterSpacing: 0.4,
    },
  });
